var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlowsamLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 513.21,
    height: 92.91,
    viewBox: "0 0 513.21 92.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M201.05,56.8a5.82,5.82,0,0,0-1.78,4.65v5h12.21v8.65H199.27v38.08H187.43V75.11h-6.38V66.46h6.38V61.81a16.88,16.88,0,0,1,2.37-9.15,15,15,0,0,1,6.33-5.7,19.59,19.59,0,0,1,8.6-1.91,20.53,20.53,0,0,1,8.93,2.09l-2.09,9.57a17.09,17.09,0,0,0-6-1.46,6.6,6.6,0,0,0-4.5,1.55M220.4,45.6h11.84v67.59H220.4Z",
    transform: "translate(-43.68 -36.01)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.39,67.19a22.37,22.37,0,0,1,9,8.69,25.31,25.31,0,0,1,3.24,12.89,25.73,25.73,0,0,1-3.24,13,22.24,22.24,0,0,1-9,8.74,27.81,27.81,0,0,1-13.35,3.1,28.23,28.23,0,0,1-13.48-3.1,22.12,22.12,0,0,1-9.06-8.74,25.73,25.73,0,0,1-3.24-13,25.31,25.31,0,0,1,3.24-12.89,22.25,22.25,0,0,1,9.06-8.69A28.23,28.23,0,0,1,267,64.09a27.81,27.81,0,0,1,13.35,3.1M257,78.3A15,15,0,0,0,253.19,89,15,15,0,0,0,257,99.61a13,13,0,0,0,10,4.1,12.83,12.83,0,0,0,9.84-4.1A15,15,0,0,0,280.7,89a15,15,0,0,0-3.82-10.66A12.86,12.86,0,0,0,267,74.2a13.08,13.08,0,0,0-10,4.1",
    transform: "translate(-43.68 -36.01)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.14 28.53 260.35 28.44 272.28 65.24 283.85 28.44 295.78 28.44 307.53 65.24 319.19 28.44 331.12 28.44 313.45 77.17 301.33 77.17 289.68 42.83 278.11 77.17 265.99 77.17 248.14 28.53",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.44,74.38a23.39,23.39,0,0,0-7-1.18,9.51,9.51,0,0,0-4.79,1,3.51,3.51,0,0,0-1.77,3.24A3.83,3.83,0,0,0,391.15,81a36,36,0,0,0,7.06,2.59,68.17,68.17,0,0,1,8.38,3,15.67,15.67,0,0,1,5.69,4.47,11.92,11.92,0,0,1,2.42,7.78,12.56,12.56,0,0,1-5.47,10.94q-5.46,3.83-13.75,3.82a34.8,34.8,0,0,1-11-1.78,25.85,25.85,0,0,1-9.11-5l4.1-8.29a24.05,24.05,0,0,0,7.84,4.42,26.23,26.23,0,0,0,8.65,1.59,10.39,10.39,0,0,0,5.24-1.14,3.7,3.7,0,0,0,2-3.41,4.13,4.13,0,0,0-2.28-3.83,40.24,40.24,0,0,0-7.38-2.82,62.38,62.38,0,0,1-8-2.87,14.5,14.5,0,0,1-5.38-4.28,11.74,11.74,0,0,1-2.28-7.52q0-7.18,5.24-11t13.16-3.78a33.86,33.86,0,0,1,9.52,1.36,29.54,29.54,0,0,1,8.34,3.83l-4.28,8.56a35,35,0,0,0-7.34-3.28",
    transform: "translate(-43.68 -36.01)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,113.19v-5.92a16,16,0,0,1-6.56,4.82,24,24,0,0,1-9.2,1.64,19.55,19.55,0,0,1-9-2,14.35,14.35,0,0,1-6-5.42,14.58,14.58,0,0,1-2.09-7.74A13,13,0,0,1,426,87.91q4.83-3.87,13.67-4h14.21V82.67A8.19,8.19,0,0,0,451,76q-2.82-2.37-8.19-2.37-6.93,0-14.49,4.56L424.08,70a53.58,53.58,0,0,1,10.43-4.6,38.32,38.32,0,0,1,11-1.41q9.47,0,14.71,4.55t5.33,12.75l.09,31.89Zm-4.19-11a8.41,8.41,0,0,0,4.1-6V91.87h-12.3q-4.74,0-7,1.41a5,5,0,0,0-2.23,4.6,5.91,5.91,0,0,0,2.32,4.92,10,10,0,0,0,6.33,1.82,15.49,15.49,0,0,0,8.75-2.41",
    transform: "translate(-43.68 -36.01)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.15,69.05q4.74,5.06,4.74,13.71v30.43H545v-27q0-5.19-2.87-8.15a10.35,10.35,0,0,0-7.79-3,11.67,11.67,0,0,0-9,4.1A14.79,14.79,0,0,0,522,89.14v24H510.07v-27q0-5.19-2.82-8.15a10.23,10.23,0,0,0-7.75-3,11.8,11.8,0,0,0-9.06,4.1,14.79,14.79,0,0,0-3.32,9.93v24H475.27V64.45h11.85v9q4.81-9.28,17.12-9.47a18,18,0,0,1,10.7,3A15.9,15.9,0,0,1,521,75.66Q525.65,64.19,539.13,64q8.28,0,13,5",
    transform: "translate(-43.68 -36.01)",
    fill: "#404040"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.74,97.26a15.59,15.59,0,0,1-4.61.7h0a15.5,15.5,0,0,0,15.17-12.37A15.53,15.53,0,0,1,94.74,97.26Z",
    transform: "translate(-43.68 -36.01)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.97 61.94 30.97 61.94 30.97 61.94 30.97 61.94 30.97 61.94 30.97 61.94",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.11,67H105.62V82.47h0a16,16,0,0,1-.31,3.12A15.5,15.5,0,0,1,90.14,98H74.65v15.48a15.49,15.49,0,1,0,31,0V98h15.49a15.49,15.49,0,0,0,0-31Z",
    transform: "translate(-43.68 -36.01)",
    fill: "#39d587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.43,53.79c-1.11,7.69-8,13.19-15.81,13.19h0c7.77,0,14.7-5.5,15.81-13.19a16,16,0,0,0,.11-3.51A16,16,0,0,1,136.43,53.79Z",
    transform: "translate(-43.68 -36.01)",
    fill: "#39d587",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.62,82.47A15.5,15.5,0,0,1,94.74,97.26a15.53,15.53,0,0,0,10.57-11.67,16,16,0,0,0,.31-3.12Z",
    transform: "translate(-43.68 -36.01)",
    fill: "#39d587",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.97 61.94 30.97 61.94 30.97 61.94 30.97 61.94 30.97 61.94",
    fill: "#39d587",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.65,51.5a15.36,15.36,0,0,1,1.22-6,15.36,15.36,0,0,0-1.22,6V67h0Z",
    transform: "translate(-43.68 -36.01)",
    fill: "#39d587",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.62,67h0V82.47h0a16,16,0,0,1-.31,3.12,16,16,0,0,0,.31-3.12h0V67Z",
    transform: "translate(-43.68 -36.01)",
    fill: "#39d587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.62,67h0V82.47h0a16,16,0,0,1-.31,3.12,16,16,0,0,0,.31-3.12h0V67Z",
    transform: "translate(-43.68 -36.01)",
    fill: "#39d587",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.13,98h0a15.59,15.59,0,0,0,4.61-.7A15.59,15.59,0,0,1,90.13,98Z",
    transform: "translate(-43.68 -36.01)",
    fill: "#39d587",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36,45.43a15.4,15.4,0,0,1,1.18,4.85A15.4,15.4,0,0,0,135.36,45.43Z",
    transform: "translate(-43.68 -36.01)",
    fill: "#39d587",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.65,98V67H59.16a15.49,15.49,0,0,0,0,31H74.65Z",
    transform: "translate(-43.68 -36.01)",
    fill: "#c3f2d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.65,98H90.13a15.48,15.48,0,0,0,15.49-15.49V67h15c7.77,0,14.7-5.5,15.81-13.19a16,16,0,0,0,.11-3.51,15.4,15.4,0,0,0-1.18-4.85q-.33-.75-.72-1.47a15.5,15.5,0,0,0-13.53-8h-31A15.48,15.48,0,0,0,74.65,51.5V67h0Z",
    transform: "translate(-43.68 -36.01)",
    fill: "#39d587",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.65,98H90.13a15.48,15.48,0,0,0,15.49-15.49V67h15c7.77,0,14.7-5.5,15.81-13.19a16,16,0,0,0,.11-3.51,15.4,15.4,0,0,0-1.18-4.85q-.33-.75-.72-1.47a15.5,15.5,0,0,0-13.53-8h-31A15.48,15.48,0,0,0,74.65,51.5V67h0Z",
    transform: "translate(-43.68 -36.01)",
    fill: "#8de4b2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.94 30.97 61.94 30.97 61.94 30.97 61.94 30.97",
    fill: "#39d587"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.94 30.97 61.94 30.97 61.94 30.97 61.94 30.97",
    fill: "#39d587",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.94 30.97 61.94 30.97 61.94 30.97 61.94 30.97",
    fill: "#39d587",
    opacity: 0.25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowsamLogo);
export default __webpack_public_path__ + "static/media/flowsam-logo.5f8ee2a2080f2b9a9981a9093fa76cfa.svg";
export { ForwardRef as ReactComponent };